import *as _ from 'lodash'
import {ErrorMessage_restate, WarningMessage_restate} from "../PA.Core/Basic/MessageUtils";
import {GeneralLedgerBO} from "./GeneralLedgerBO";
import {SnapshotParameterBO} from "./SnapshotParameterBO";
import {
    WB_Snapshot_ParamSARRow,
    WB_Snapshot_ParamGLRRow, WB_Snapshot_ParamGLELRRow,
} from "../PA.Core/PAdbSchemaRows";


export class SnapshotParameterBOValidations {

    static async ValidateFields(aBO: SnapshotParameterBO): Promise<void> {

        if (!aBO.WB_SnapshotParameter.isActive)
            return

        const mp = aBO.ValidateMessageProvider
        if (aBO.WB_SnapshotParameter.cif.WB_ENTITY_ID_PRODUCT <= 0)
            WarningMessage_restate(mp, true, "noProductLevelInResolution", "The snapshot template is missing the product level definition in the snapshot resolution")

        if (!_.filter(aBO.WB_SnapshotParameter.WB_Snapshot_ParamSARRows, row => row.isActive).length)
            WarningMessage_restate(mp, true, "noSalesAreaInResolution", "The snapshot template is missing the sales area definition in the snapshot scope")


        let bMissingFields: boolean = false
        let defaultRow = _.first(_.filter(aBO.WB_SnapshotParameter.WB_Snapshot_ParamGLRRows, aRow => aRow.isActive && aRow.cif.WB_EVTSTYPE_ID == 0))
        if (!_.isEmpty(defaultRow) && (
            // defaultRow.cif.WB_FUNDTYPE_ID == 0 ||
            defaultRow.cif.PAYMENT_METHOD == "" ||
            defaultRow.cif.GL_EXPENSETYPE_ID == ""
            // defaultRow.cif.WB_GLACCT_ID_LIABILITY == 0
        )) {
            bMissingFields = true
        }

        WarningMessage_restate(mp,
            bMissingFields,
            "emptyFields", "GL Accounts Assignments - Matching Criteria/ Liability Account missing for the 'All Spend Types' row.")

        // RTE Allocation - Allocation method
        const defaultRows = _.filter(aBO.WB_SnapshotParameter.WB_Snapshot_ParamAMRRows, (aRow) => aRow.isActive && aRow.isDefaultRow);
        if (defaultRows.length > 1) {
            ErrorMessage_restate(mp, true, "DuplicateDefault", {
                Title: "Duplicate default rows exist in Allocation methods table",
                Desc: "Duplicate default rows exist in Allocation methods table",
            })
        }
        const amrDefaultRow = _.first(defaultRows);
        if (!_.isEmpty(amrDefaultRow)) {
            let bConditionTypeMissing = false
            if (amrDefaultRow.cif.TIME_ALLOCATION_METHOD.indexOf("LeadTime") !== -1) {
                if (_.isEmpty(amrDefaultRow.WB_ProductConditionTypeRow) || _.isEmpty(amrDefaultRow.WB_ProductConditionTypeDefaultRow)) {
                    bConditionTypeMissing = true
                }
            }
            let bAmrDefaultRowMissingField = false
            if (amrDefaultRow.cif.RATE_BASIS_ID === "" ||
                (amrDefaultRow.cif.PRODUCT_ALLOCATION_METHOD === "" && aBO.WB_SnapshotParameter.cif.SOURCE_LEVEL == "Allocate") ||
                (amrDefaultRow.cif.TIME_ALLOCATION_METHOD === "" && aBO.WB_SnapshotParameter.cif.SOURCE_LEVEL == "Allocate") ||
                (amrDefaultRow.cif.COST_RECOGNITION_DATES === "" && aBO.WB_SnapshotParameter.cif.SOURCE_LEVEL == "Allocate") ||
                bConditionTypeMissing
            ) {
                bAmrDefaultRowMissingField = true
            }
            WarningMessage_restate(mp, bAmrDefaultRowMissingField, "AMREmptyFields", {
                Title: 'RTE Allocation - Missing configuration',
                Desc: `Missing configuration in the Allocation methods table: All fields must be filled for the "All Spend Types" row`
            })
        }

        //GL Accounts Assignment Tab
        let snapshotParamGLELRelRows: WB_Snapshot_ParamGLELRRow[] = _.filter(aBO.WB_SnapshotParameter.WB_Snapshot_ParamGLELRRows, aGLELRow => aGLELRow.isActive)
        let emptyLiabilityId = _.filter(snapshotParamGLELRelRows, aGLELRow => aGLELRow.cif.WB_GLACCT_ID_LIABILITY == 0)
        if (emptyLiabilityId.length > 0) {
            WarningMessage_restate(mp, true, "MissingLiabilityRel", {
                Title: 'Expense account is missing a liability account relationship ',
                Desc: `Missing configuration in the Expense and Liability Accounts Relationship table: Liability Account cannot be empty`
            })
        }

        //check for duplicate rows
        let activeGLRRows: WB_Snapshot_ParamGLRRow[] = _.filter(aBO.WB_SnapshotParameter.WB_Snapshot_ParamGLRRows, aGLRow => aGLRow.isActive)
        let uniqRows = _.uniqWith(
            activeGLRRows,
            (aRowA, aRowB) =>
                aRowA.cif.WB_EVTSTYPE_ID === aRowB.cif.WB_EVTSTYPE_ID &&
                aRowA.cif.WB_FUNDTYPE_ID === aRowB.cif.WB_FUNDTYPE_ID &&
                aRowA.cif.WB_GLACCT_ID_EXPENSE === aRowB.cif.WB_GLACCT_ID_EXPENSE &&
                aRowA.cif.PAYMENT_METHOD === aRowB.cif.PAYMENT_METHOD
        );
        if (uniqRows.length != activeGLRRows.length) {
            ErrorMessage_restate(mp, true, "DuplicateRel", {
                Title: 'Duplicate rows existing in Spend Accounts Table ',
                Desc: `Duplicate rows existing in Spend Accounts Table `
            })
        }

    }
}